import type { MunicipalityOption } from '@/components/documents/MunicipalityLinkFields';
import type { UploadConfig } from '@/lib/fileLibraryUploadConfig';
import DocumentForm from './DocumentForm';

interface DocumentNewProps {
  errors: Record<string, string[]>;
  stateOptions: string[];
  fileLibraryUpload: UploadConfig;
  municipalities?: MunicipalityOption[];
}

export default function DocumentNew({ errors = {}, stateOptions, fileLibraryUpload, municipalities = [] }: DocumentNewProps) {
  const emptyDocument = {
    name: '',
    description: '',
    update_cadence: '',
  };

  return (
    <DocumentForm
      document={emptyDocument}
      isEdit={false}
      errors={errors}
      stateOptions={stateOptions}
      fileLibraryUpload={fileLibraryUpload}
      municipalities={municipalities}
    />
  );
}